function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Log from '@deephaven/log';
import { TableUtils } from '@deephaven/jsapi-utils';
import { set } from 'lodash';
import { assertNotNull, bindAllMethods } from '@deephaven/utils';
var log = Log.module('ChartUtils');
var BUSINESS_COLUMN_TYPE = 'io.deephaven.time.DateTime';
var MILLIS_PER_HOUR = 3600000;
var NANOS_PER_MILLI = 1000000;
function isDateWrapper(value) {
  return value.asDate !== undefined;
}
function isLongWrapper(value) {
  return value.asNumber !== undefined;
}
function isDateTimeColumnFormatter(value) {
  return value.dhTimeZone !== undefined;
}
function isRangedPlotlyAxis(value) {
  return value != null && value.range != null && (value.autorange === false || value.autorange === undefined);
}

/**
 * Check if WebGL is supported in the current environment.
 * Most modern browsers do support WebGL, but it's possible to disable it and it is also not available
 * in some headless environments, which can affect e2e tests.
 *
 * https://github.com/microsoft/playwright/issues/13146
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1375585
 *
 * @returns True if Web GL is supported, false otherwise
 */
export function isWebGLSupported() {
  try {
    // https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/By_example/Detect_WebGL
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    return gl != null && gl instanceof WebGLRenderingContext;
  } catch (e) {
    return false;
  }
}
var IS_WEBGL_SUPPORTED = isWebGLSupported();
class ChartUtils {
  /**
   * Generate the plotly error bar data from the passed in data.
   * Iris passes in the values as absolute, plotly needs them as relative.
   * @param x The main data array
   * @param xLow The absolute low values
   * @param xHigh
   *
   * @returns The error_x object required by plotly, or null if none is required
   */
  static getPlotlyErrorBars(x, xLow, xHigh) {
    var array = xHigh.map((value, i) => value - x[i]);
    var arrayminus = xLow.map((value, i) => x[i] - value);
    return {
      type: 'data',
      symmetric: false,
      array,
      arrayminus
    };
  }
  static convertNumberPrefix(prefix) {
    return prefix.replace(/\u00A4\u00A4/g, 'USD').replace(/\u00A4/g, '$');
  }
  static getPlotlyNumberFormat(formatter, columnType, formatPattern) {
    if (formatPattern == null || formatPattern === '') {
      return null;
    }

    // We translate java formatting: https://docs.oracle.com/javase/7/docs/api/java/text/DecimalFormat.html
    // Into d3 number formatting: https://github.com/d3/d3-format
    // We can't translate number formatting exactly, but should be able to translate the most common cases
    // First split it into the subpatterns; currently only handling the positive subpattern, ignoring the rest
    var subpatterns = formatPattern.split(';');
    var matchArray = subpatterns[0].match(/^([^#,0.]*)([#,]*)([0,]*)(\.?)(0*)(#*)(E?0*)(%?)(.*)/);
    assertNotNull(matchArray);
    var _matchArray = _slicedToArray(matchArray, 10),
      prefix = _matchArray[1],
      placeholderDigits = _matchArray[2],
      zeroDigits = _matchArray[3],
      decimalDigits = _matchArray[5],
      optionalDecimalDigits = _matchArray[6],
      numberType = _matchArray[7],
      percentSign = _matchArray[8],
      suffix = _matchArray[9];
    var paddingLength = zeroDigits.replace(',', '').length;
    var isCommaSeparated = placeholderDigits.indexOf(',') >= 0 || zeroDigits.indexOf(',') >= 0;
    var comma = isCommaSeparated ? ',' : '';
    var plotlyNumberType = numberType != null && numberType !== '' ? 'e' : 'f';
    var type = percentSign !== '' ? percentSign : plotlyNumberType;
    var decimalLength = decimalDigits.length + optionalDecimalDigits.length;
    // IDS-4565 Plotly uses an older version of d3 which doesn't support the trim option or negative brackets
    // If plotly updates it's d3 version, this should be re-enabled
    // const trimOption = optionalDecimalDigits.length > 0 ? '~' : '';
    var trimOption = '';
    var tickformat = "0".concat(paddingLength).concat(comma, ".").concat(decimalLength).concat(trimOption).concat(type);
    var tickprefix = ChartUtils.convertNumberPrefix(prefix);
    // prefix and suffix are processed the same
    var ticksuffix = ChartUtils.convertNumberPrefix(suffix);
    return {
      tickformat,
      tickprefix,
      ticksuffix,
      automargin: true
    };
  }

  /**
   * Adds tick spacing for an axis that has gapBetweenMajorTicks defined.
   *
   * @param axisFormat the current axis format, may be null
   * @param axis the current axis
   * @param isDateType indicates if the columns is a date type
   */
  static addTickSpacing(axisFormat, axis, isDateType) {
    var gapBetweenMajorTicks = axis.gapBetweenMajorTicks;
    if (gapBetweenMajorTicks != null && gapBetweenMajorTicks > 0) {
      var updatedFormat = axisFormat || {};
      var tickSpacing = gapBetweenMajorTicks;
      if (isDateType) {
        // Need to convert from nanoseconds to milliseconds
        tickSpacing = gapBetweenMajorTicks / NANOS_PER_MILLI;
      }
      if (axis.log) {
        tickSpacing = Math.log(tickSpacing);
      }
      // Note that tickmode defaults to 'auto'
      updatedFormat.tickmode = 'linear';
      updatedFormat.dtick = tickSpacing;
      return updatedFormat;
    }
    return axisFormat;
  }

  /**
   * Retrieve the data source for a given axis in a chart
   * @param chart The chart to get the source for
   * @param axis The axis to find the source for
   * @returns The first source matching this axis
   */
  static getSourceForAxis(chart, axis) {
    for (var i = 0; i < chart.series.length; i += 1) {
      var series = chart.series[i];
      for (var j = 0; j < series.sources.length; j += 1) {
        var source = series.sources[j];
        if (source.axis === axis) {
          return source;
        }
      }
    }
    return null;
  }

  /**
   * Get visibility setting for the series object
   * @param  name The series name to get the visibility for
   * @param  settings Chart settings
   * @returns True for visible series and 'legendonly' for hidden
   */
  static getSeriesVisibility(name, settings) {
    if (settings != null && settings.hiddenSeries != null && settings.hiddenSeries.includes(name)) {
      return 'legendonly';
    }
    return true;
  }

  /**
   * Get hidden labels array from chart settings
   * @param settings Chart settings
   * @returns Array of hidden series names
   */
  static getHiddenLabels(settings) {
    if (settings !== null && settings !== void 0 && settings.hiddenSeries) {
      return [...settings.hiddenSeries];
    }
    return [];
  }

  /**
   * Create a default series data object. Apply styling to the object afterward.
   * @returns A simple series data object with no styling
   */
  static makeSeriesData(type, mode, name, showLegend) {
    var orientation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ChartUtils.ORIENTATION.VERTICAL;
    return {
      type,
      mode,
      name,
      orientation,
      showlegend: showLegend !== null && showLegend !== void 0 ? showLegend : undefined
    };
  }

  /**
   * Get the Plotly marker symbol for the provided Deephaven shape
   * Deephaven shapes: https://deephaven.io/enterprise/docs/plotting/visual-formatting/#point-formatting
   * Plotly shapes: https://plotly.com/javascript/reference/scattergl/#scattergl-marker-symbol
   * Table of plotly shapes: https://plotly.com/python/marker-style/#custom-marker-symbols
   * @param deephavenShape Deephaven shape to get the marker symbol for
   */
  static getMarkerSymbol(deephavenShape) {
    switch (deephavenShape) {
      case 'SQUARE':
        return 'square';
      case 'CIRCLE':
        return 'circle';
      case 'DIAMOND':
        return 'diamond';
      case 'UP_TRIANGLE':
        return 'triangle-up';
      case 'DOWN_TRIANGLE':
        return 'triangle-down';
      case 'RIGHT_TRIANGLE':
        return 'triangle-right';
      case 'LEFT_TRIANGLE':
        return 'triangle-left';
      // There don't seem to be any plotly equivalents for ellipse or rectangles
      // Rectangles could be `line-ew`, `line-ns`, or `hourglass` and `bowtie` instead?
      // Ellipse could be `asterisk` or `diamond-wide` instead?
      // Just throw an error, we've already got a bunch of types.
      case 'ELLIPSE':
      case 'HORIZONTAL_RECTANGLE':
      case 'VERTICAL_RECTANGLE':
      default:
        throw new Error("Unrecognized shape ".concat(deephavenShape));
    }
  }

  /**
   * Get all axes for a given `Figure`. Iterates through all charts axes and concatenates them.
   * @param figure Figure to get all axes for
   */
  static getAllAxes(figure) {
    return figure.charts.reduce((axes, chart) => [...axes, ...chart.axes], []);
  }

  /**
   * Get the axis type map for the figure provided
   * @param figure Figure to get the type map for
   * @returns Axis type map for the figure provided
   */
  static getAxisTypeMap(figure) {
    var axes = ChartUtils.getAllAxes(figure);
    return ChartUtils.groupArray(axes, 'type');
  }

  /**
   * Retrieve the chart that contains the passed in series from the figure
   * @param figure The figure to retrieve the chart from
   * @param series The series to get the chart for
   */
  static getChartForSeries(figure, series) {
    var charts = figure.charts;
    for (var i = 0; i < charts.length; i += 1) {
      var _chart = charts[i];
      for (var j = 0; j < _chart.series.length; j += 1) {
        if (series === _chart.series[j]) {
          return _chart;
        }
      }
    }
    return null;
  }

  /**
   * Get an object mapping axis to their ranges
   * @param layout The plotly layout object to get the ranges from
   * @returns An object mapping the axis name to it's range
   */
  static getLayoutRanges(layout) {
    var ranges = {};
    var keys = Object.keys(layout).filter(key => key.indexOf('axis') >= 0);
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = layout[key];
      if (isRangedPlotlyAxis(value)) {
        // Only want to add the range if it's not autoranged
        ranges[key] = [...value.range];
      }
    }
    return ranges;
  }
  static getAxisLayoutProperty(axisProperty, axisIndex) {
    var axisIndexString = axisIndex > 0 ? "".concat(axisIndex + 1) : '';
    return "".concat(axisProperty !== null && axisProperty !== void 0 ? axisProperty : '', "axis").concat(axisIndexString);
  }

  /**
   * Converts an open or close period to a declimal. e.g '09:30" to 9.5
   *
   * @param period the open or close value of the period
   */
  static periodToDecimal(period) {
    var values = period.split(':');
    return Number(values[0]) + Number(values[1]) / 60;
  }

  /**
   * Converts a decimal to a period. e.g 9.5 to '09:30'
   *
   * @param decimal the decimal value to
   */
  static decimalToPeriod(decimal) {
    var hours = Math.floor(decimal);
    var minutes = Math.round((decimal - hours) * 60);
    return "".concat(hours.toString().padStart(2, '0'), ":").concat(minutes.toString().padStart(2, '0'));
  }

  /**
   * Groups an array and returns a map
   * @param array The object to group
   * @param property The property name to group by
   * @returns A map containing the items grouped by their values for the property
   */
  static groupArray(array, property) {
    return array.reduce((result, item) => {
      var _result$get;
      var key = item[property];
      var group = (_result$get = result.get(key)) !== null && _result$get !== void 0 ? _result$get : [];
      group.push(item);
      result.set(key, group);
      return result;
    }, new Map());
  }

  /**
   * Parses the colorway value of a theme and returns an array of colors
   * Value could be a single string with space separated colors or already be an
   * array of strings representing the colorway
   * @param colorway The colorway value to normalize
   * @returns Colorway array for the theme or undefined
   */
  static normalizeColorway(colorway) {
    if (colorway == null) {
      return;
    }
    if (Array.isArray(colorway)) {
      return colorway;
    }
    if (typeof colorway === 'string') {
      return colorway.split(' ');
    }
    log.warn("Unexpected colorway format: ".concat(colorway));
  }
  static titleFromSettings(settings) {
    var series = settings.series,
      xAxis = settings.xAxis,
      _settings$title = settings.title,
      title = _settings$title === void 0 ? "".concat((series !== null && series !== void 0 ? series : []).join(', '), " by ").concat(xAxis) : _settings$title;
    return title;
  }
  static getTimeZoneDiff(calendarTimeZone, formatterTimeZone) {
    return formatterTimeZone ? (calendarTimeZone.standardOffset - formatterTimeZone.standardOffset) / 60 : 0;
  }

  /**
   * Creates closed periods for a partial holiday.
   *
   * @param holidayPeriods the business periods for the holiday
   * @param calendarPeriods the business periods for the calendar
   * @returns an array of closed ranges for the partial holiday. Should be the ranges during the regular business hours that are _not_ specified by the holiday periods.
   */
  static createClosedRangesForPartialHoliday(holidayPeriods, calendarPeriods) {
    // First restrict the periods to only those that are actual business periods.
    var calendarRanges = calendarPeriods.map(period => [ChartUtils.periodToDecimal(period.open), ChartUtils.periodToDecimal(period.close)]);
    calendarRanges.sort((a, b) => a[0] - b[0]);
    if (calendarRanges.length === 0) {
      calendarRanges.push([0, 24]);
    }
    var holidayRanges = holidayPeriods.map(period => [ChartUtils.periodToDecimal(period.open), ChartUtils.periodToDecimal(period.close)]);
    holidayRanges.sort((a, b) => a[0] - b[0]);
    var closedRanges = [];

    // Separate index cursor for the holiday ranges
    for (var c = 0; c < calendarRanges.length; c += 1) {
      var calendarRange = calendarRanges[c];
      var lastClose = calendarRange[0];
      for (var h = 0; h < holidayRanges.length; h += 1) {
        var holidayRange = holidayRanges[h];
        if (holidayRange[1] > lastClose && holidayRange[0] < calendarRange[1]) {
          if (holidayRange[0] > lastClose) {
            closedRanges.push([lastClose, holidayRange[0]]);
          }
          // eslint-disable-next-line prefer-destructuring
          lastClose = holidayRange[1];
        }
      }
      if (lastClose < calendarRange[1]) {
        closedRanges.push([lastClose, calendarRange[1]]);
      }
    }
    return closedRanges;
  }
  constructor(dh) {
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "daysOfWeek", void 0);
    this.dh = dh;
    this.daysOfWeek = Object.freeze(dh.calendar.DayOfWeek.values());
    bindAllMethods(this);
  }

  /**
   * Retrieve the axis formats from the provided figure.
   * Currently defaults to just the x/y axes.
   * @param figure The figure to get the axis formats for
   * @param formatter The formatter to use when getting the axis format
   * @returns A map of axis layout property names to axis formats
   */
  getAxisFormats(figure, formatter) {
    var axisFormats = new Map();
    var nullFormat = {
      tickformat: null,
      ticksuffix: null
    };
    var allAxes = ChartUtils.getAllAxes(figure);
    var axisTypeMap = ChartUtils.groupArray(allAxes, 'type');
    var charts = figure.charts;
    for (var i = 0; i < charts.length; i += 1) {
      var _chart2 = charts[i];
      for (var j = 0; j < _chart2.series.length; j += 1) {
        var series = _chart2.series[j];
        var sources = series.sources;
        var axisSources = sources.filter(source => source.axis);
        for (var k = 0; k < axisSources.length; k += 1) {
          var source = axisSources[k];
          var _axis = source.axis;
          var axisType = _axis.type;
          var typeAxes = axisTypeMap.get(axisType);
          assertNotNull(typeAxes);
          var axisIndex = typeAxes.indexOf(_axis);
          var axisProperty = this.getAxisPropertyName(axisType);
          if (axisProperty != null) {
            var axisLayoutProperty = ChartUtils.getAxisLayoutProperty(axisProperty, axisIndex);
            if (axisFormats.has(axisLayoutProperty)) {
              log.debug("".concat(axisLayoutProperty, " already added."));
            } else {
              log.debug("Adding ".concat(axisLayoutProperty, " to axisFormats."));
              var axisFormat = this.getPlotlyAxisFormat(source, formatter);
              if (axisFormat === null) {
                axisFormats.set(axisLayoutProperty, nullFormat);
              } else {
                axisFormats.set(axisLayoutProperty, axisFormat);
                var businessCalendar = _axis.businessCalendar;
                if (businessCalendar != null) {
                  axisFormat.rangebreaks = this.createRangeBreaksFromBusinessCalendar(businessCalendar, formatter);
                }
                if (axisFormats.size === _chart2.axes.length) {
                  return axisFormats;
                }
              }
            }
          }
        }
      }
    }
    return axisFormats;
  }

  /**
   * Converts the Iris plot style into a plotly chart type
   * @param plotStyle The plotStyle to use, see dh.plot.SeriesPlotStyle
   * @param isBusinessTime If the plot is using business time for an axis
   * @param allowWebGL If WebGL is allowedd
   */
  getPlotlyChartType(plotStyle, isBusinessTime) {
    var allowWebGL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var dh = this.dh;
    switch (plotStyle) {
      case dh.plot.SeriesPlotStyle.SCATTER:
      case dh.plot.SeriesPlotStyle.LINE:
        // scattergl mode is more performant (usually), but doesn't support the rangebreaks we need for businessTime calendars
        // In some cases, WebGL is less performant (like in virtual desktop environments), so we also allow the option of the user explicitly disabling it even if it's supported
        return !isBusinessTime && IS_WEBGL_SUPPORTED && allowWebGL ? 'scattergl' : 'scatter';
      case dh.plot.SeriesPlotStyle.BAR:
      case dh.plot.SeriesPlotStyle.STACKED_BAR:
        return 'bar';
      case dh.plot.SeriesPlotStyle.PIE:
        return 'pie';
      case dh.plot.SeriesPlotStyle.TREEMAP:
        return 'treemap';
      case dh.plot.SeriesPlotStyle.HISTOGRAM:
        return 'histogram';
      case dh.plot.SeriesPlotStyle.OHLC:
        return 'ohlc';
      default:
        return undefined;
    }
  }

  /**
   * Converts the Iris plot style into a plotly chart mode
   * @param plotStyle The plotStyle to use, see dh.plot.SeriesPlotStyle.*
   * @param areLinesVisible Whether lines are visible or not
   * @param areShapesVisible Whether shapes are visible or not
   */
  getPlotlyChartMode(plotStyle, areLinesVisible, areShapesVisible) {
    var dh = this.dh;
    var modes = new Set();
    switch (plotStyle) {
      case dh.plot.SeriesPlotStyle.SCATTER:
        // Default to only showing shapes in scatter plots
        if (areLinesVisible !== null && areLinesVisible !== void 0 ? areLinesVisible : false) {
          modes.add(ChartUtils.MODE_LINES);
        }
        if (areShapesVisible !== null && areShapesVisible !== void 0 ? areShapesVisible : true) {
          modes.add(ChartUtils.MODE_MARKERS);
        }
        break;
      case dh.plot.SeriesPlotStyle.LINE:
        // Default to only showing lines in line series
        if (areLinesVisible !== null && areLinesVisible !== void 0 ? areLinesVisible : true) {
          modes.add(ChartUtils.MODE_LINES);
        }
        if (areShapesVisible !== null && areShapesVisible !== void 0 ? areShapesVisible : false) {
          modes.add(ChartUtils.MODE_MARKERS);
        }
        break;
      default:
        break;
    }
    return modes.size > 0 ? [...modes].join('+') : undefined;
  }

  /**
   * Get the property to set on the series data for plotly
   * @param plotStyle The plot style of the series
   * @param sourceType The source type for the series
   */
  getPlotlyProperty(plotStyle, sourceType) {
    var dh = this.dh;
    switch (plotStyle) {
      case dh.plot.SeriesPlotStyle.PIE:
        switch (sourceType) {
          case dh.plot.SourceType.X:
            return 'labels';
          case dh.plot.SourceType.Y:
            return 'values';
          default:
            break;
        }
        break;
      case dh.plot.SeriesPlotStyle.OHLC:
        switch (sourceType) {
          case dh.plot.SourceType.TIME:
            return 'x';
          default:
            break;
        }
        break;
      case dh.plot.SeriesPlotStyle.TREEMAP:
        switch (sourceType) {
          case dh.plot.SourceType.X:
            return 'ids';
          case dh.plot.SourceType.Y:
            return 'values';
          case dh.plot.SourceType.LABEL:
            return 'labels';
          case dh.plot.SourceType.PARENT:
            return 'parents';
          case dh.plot.SourceType.COLOR:
            return 'marker.colors';
          default:
            break;
        }
        break;
      default:
        break;
    }
    switch (sourceType) {
      case dh.plot.SourceType.X:
        return 'x';
      case dh.plot.SourceType.Y:
        return 'y';
      case dh.plot.SourceType.Z:
        return 'z';
      case dh.plot.SourceType.X_LOW:
        return 'xLow';
      case dh.plot.SourceType.X_HIGH:
        return 'xHigh';
      case dh.plot.SourceType.Y_LOW:
        return 'yLow';
      case dh.plot.SourceType.Y_HIGH:
        return 'yHigh';
      case dh.plot.SourceType.TIME:
        return 'time';
      case dh.plot.SourceType.OPEN:
        return 'open';
      case dh.plot.SourceType.HIGH:
        return 'high';
      case dh.plot.SourceType.LOW:
        return 'low';
      case dh.plot.SourceType.CLOSE:
        return 'close';
      case dh.plot.SourceType.SHAPE:
        return 'shape';
      case dh.plot.SourceType.SIZE:
        return 'size';
      case dh.plot.SourceType.LABEL:
        return 'label';
      case dh.plot.SourceType.COLOR:
        return 'color';
      case dh.plot.SourceType.PARENT:
        return 'parent';
      case dh.plot.SourceType.HOVER_TEXT:
        return 'hovertext';
      case dh.plot.SourceType.TEXT:
        return 'text';
      default:
        throw new Error("Unrecognized source type: ".concat(sourceType));
    }
  }
  getPlotlySeriesOrientation(series) {
    var _sources$;
    var dh = this.dh;
    var sources = series.sources;
    if (sources.length === 2 && ((_sources$ = sources[0]) === null || _sources$ === void 0 || (_sources$ = _sources$.axis) === null || _sources$ === void 0 ? void 0 : _sources$.type) === dh.plot.AxisType.Y) {
      return ChartUtils.ORIENTATION.HORIZONTAL;
    }
    return ChartUtils.ORIENTATION.VERTICAL;
  }

  /**
   * Create a data series (trace) for use with plotly
   * @param series The series to create the series data with
   * @param axisTypeMap The map of axes grouped by type
   * @param seriesVisibility Visibility setting for the series
   * @returns The series data (trace) object for use with plotly.
   */
  makeSeriesDataFromSeries(series, axisTypeMap, seriesVisibility) {
    var showLegend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var allowWebGL = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var name = series.name,
      isLinesVisible = series.isLinesVisible,
      isShapesVisible = series.isShapesVisible,
      plotStyle = series.plotStyle,
      lineColor = series.lineColor,
      shapeColor = series.shapeColor,
      sources = series.sources,
      shape = series.shape,
      shapeSize = series.shapeSize;
    var isBusinessTime = sources.some(source => {
      var _source$axis;
      return (_source$axis = source.axis) === null || _source$axis === void 0 ? void 0 : _source$axis.businessCalendar;
    });
    var type = this.getChartType(plotStyle, isBusinessTime, allowWebGL);
    var mode = this.getPlotlyChartMode(plotStyle, isLinesVisible !== null && isLinesVisible !== void 0 ? isLinesVisible : undefined, isShapesVisible !== null && isShapesVisible !== void 0 ? isShapesVisible : undefined);
    var orientation = this.getPlotlySeriesOrientation(series);
    var seriesData = ChartUtils.makeSeriesData(type, mode, name, showLegend, orientation);
    this.addSourcesToSeriesData(seriesData, plotStyle, sources, axisTypeMap);
    this.addStylingToSeriesData(seriesData, plotStyle, lineColor, shapeColor, shape, shapeSize, seriesVisibility);
    return seriesData;
  }
  addSourcesToSeriesData(seriesDataParam, plotStyle, sources, axisTypeMap) {
    var seriesData = seriesDataParam;
    for (var k = 0; k < sources.length; k += 1) {
      var source = sources[k];
      var _axis2 = source.axis,
        sourceType = source.type;
      var dataAttributeName = this.getPlotlyProperty(plotStyle, sourceType);
      set(seriesData, dataAttributeName, []);
      var axisProperty = _axis2 != null ? this.getAxisPropertyName(_axis2.type) : null;
      if (axisProperty != null) {
        var axes = axisTypeMap.get(_axis2.type);
        if (axes) {
          var axisIndex = axes.indexOf(_axis2);
          var axisIndexString = axisIndex > 0 ? "".concat(axisIndex + 1) : '';
          seriesData["".concat(axisProperty, "axis")] = "".concat(axisProperty).concat(axisIndexString);
        }
      }
    }
  }
  addStylingToSeriesData(seriesDataParam, plotStyle) {
    var lineColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var shapeColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var shape = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var shapeSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var seriesVisibility = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var dh = this.dh;
    var seriesData = seriesDataParam;
    // Add some empty objects so we can fill them in later with details without checking for existence
    seriesData.marker = {
      line: {}
    }; // border line width on markers
    seriesData.line = {
      width: 1 // default line width for lines, should eventually be able to override
    };
    if (plotStyle === dh.plot.SeriesPlotStyle.AREA) {
      seriesData.fill = 'tozeroy';
    } else if (plotStyle === dh.plot.SeriesPlotStyle.STACKED_AREA) {
      seriesData.stackgroup = 'stack';
    } else if (plotStyle === dh.plot.SeriesPlotStyle.STEP) {
      seriesData.line.shape = 'hv'; // plot.ly horizontal then vertical step styling
    } else if (plotStyle === dh.plot.SeriesPlotStyle.HISTOGRAM) {
      // The default histfunc in plotly is 'count', but the data passed up from the API provides explicit x/y values and bins
      // Since it's converted to bar, just set the widths of each bar
      seriesData.width = [];
    } else if (plotStyle === dh.plot.SeriesPlotStyle.PIE) {
      seriesData.textinfo = 'label+percent';
    } else if (plotStyle === dh.plot.SeriesPlotStyle.TREEMAP) {
      seriesData.hoverinfo = 'text';
      seriesData.textinfo = 'label+text';
      seriesData.tiling = {
        packing: 'squarify',
        pad: 0
      };
      seriesData.textposition = 'middle center';
    }
    if (lineColor != null) {
      if (plotStyle === dh.plot.SeriesPlotStyle.BAR) {
        seriesData.marker.color = lineColor;
      } else {
        seriesData.line.color = lineColor;
      }
    }
    if (shapeColor != null) {
      seriesData.marker.color = shapeColor;
    }
    if (shape != null && shape.length > 0) {
      try {
        seriesData.marker.symbol = ChartUtils.getMarkerSymbol(shape);
      } catch (e) {
        log.warn('Unable to handle shape', shape, ':', e);
      }
    }
    if (shapeSize != null) {
      seriesData.marker.size = shapeSize * ChartUtils.DEFAULT_MARKER_SIZE;
    }

    // Skipping pie charts
    // Pie slice visibility is configured in chart layout instead of series data
    if (seriesVisibility != null && plotStyle !== dh.plot.SeriesPlotStyle.PIE) {
      seriesData.visible = seriesVisibility;
    }
  }
  getChartType(plotStyle, isBusinessTime) {
    var allowWebGL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var dh = this.dh;
    switch (plotStyle) {
      case dh.plot.SeriesPlotStyle.HISTOGRAM:
        // When reading data from the `Figure`, it already provides bins and values, so rather than using
        // plot.ly to calculate the bins and sum values, just convert it to a bar chart
        return 'bar';
      default:
        return this.getPlotlyChartType(plotStyle, isBusinessTime, allowWebGL);
    }
  }

  /**
   * Return the plotly axis property name
   * @param axisType The axis type to get the property name for
   */
  getAxisPropertyName(axisType) {
    var dh = this.dh;
    switch (axisType) {
      case dh.plot.AxisType.X:
        return 'x';
      case dh.plot.AxisType.Y:
        return 'y';
      default:
        return null;
    }
  }

  /**
   * Returns the plotly "side" value for the provided axis position
   * @param axisPosition The Iris AxisPosition of the axis
   */
  getAxisSide(axisPosition) {
    var dh = this.dh;
    switch (axisPosition) {
      case dh.plot.AxisPosition.BOTTOM:
        return 'bottom';
      case dh.plot.AxisPosition.TOP:
        return 'top';
      case dh.plot.AxisPosition.LEFT:
        return 'left';
      case dh.plot.AxisPosition.RIGHT:
        return 'right';
      default:
        return undefined;
    }
  }

  /**
   * Update the layout with all the axes information for the provided figure
   * @param figure Figure to update the axes for
   * @param layoutParam Layout object to update in place
   * @param chartAxisRangeParser Function to retrieve the axis range parser
   * @param plotWidth Width of the plot in pixels
   * @param plotHeight Height of the plot in pixels
   */
  updateFigureAxes(layoutParam, figure, chartAxisRangeParser) {
    var plotWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var plotHeight = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var layout = layoutParam;
    var figureAxes = ChartUtils.getAllAxes(figure);
    for (var i = 0; i < figure.charts.length; i += 1) {
      var _chart3 = figure.charts[i];
      var axisRangeParser = chartAxisRangeParser === null || chartAxisRangeParser === void 0 ? void 0 : chartAxisRangeParser(_chart3);
      var bounds = this.getChartBounds(figure, _chart3, plotWidth, plotHeight);
      this.updateLayoutAxes(layout, _chart3.axes, figureAxes, plotWidth, plotHeight, bounds, axisRangeParser);
    }
    this.removeStaleAxes(layout, figureAxes);
  }
  getChartBounds(figure, chart, plotWidth, plotHeight) {
    var _axisPositionMap$get;
    var dh = this.dh;
    var cols = figure.cols,
      rows = figure.rows;
    var column = chart.column,
      colspan = chart.colspan,
      row = chart.row,
      rowspan = chart.rowspan;
    var endColumn = column + colspan;
    var endRow = row + rowspan;
    var columnSize = 1 / cols;
    var rowSize = 1 / rows;
    var xMarginSize = ChartUtils.AXIS_SIZE_PX / plotWidth;
    var yMarginSize = ChartUtils.AXIS_SIZE_PX / plotHeight;
    var bounds = {
      // Need to invert the row positioning so the first one defined shows up on top instead of the bottom, since coordinates start in bottom left
      bottom: (rows - endRow) * rowSize + (endRow < rows ? yMarginSize / 2 : 0),
      top: (rows - row) * rowSize - (row > 0 ? yMarginSize / 2 : 0),
      left: column * columnSize + (column > 0 ? xMarginSize / 2 : 0),
      right: endColumn * columnSize - (endColumn < cols ? xMarginSize / 2 : 0)
    };

    // Adjust the bounds based on where the legend is
    // For now, always assume the legend is shown on the right
    var axisPositionMap = ChartUtils.groupArray(chart.axes, 'position');
    var rightAxes = (_axisPositionMap$get = axisPositionMap.get(dh.plot.AxisPosition.RIGHT)) !== null && _axisPositionMap$get !== void 0 ? _axisPositionMap$get : [];
    if (rightAxes.length > 0) {
      if (plotWidth > 0) {
        bounds.right -= (bounds.right - bounds.left) * Math.max(0, Math.min(ChartUtils.LEGEND_WIDTH_PX / plotWidth, ChartUtils.MAX_LEGEND_SIZE));
      } else {
        bounds.right -= (bounds.right - bounds.left) * ChartUtils.DEFAULT_AXIS_SIZE;
      }
    }
    return bounds;
  }
  getPlotlyDateFormat(formatter, columnType, formatPattern) {
    var dh = this.dh;
    var tickformat = formatPattern == null ? undefined : formatPattern.replace('%', '%%').replace(/S{9}/g, '%9f').replace(/S{8}/g, '%8f').replace(/S{7}/g, '%7f').replace(/S{6}/g, '%6f').replace(/S{5}/g, '%5f').replace(/S{4}/g, '%4f').replace(/S{3}/g, '%3f').replace(/S{2}/g, '%2f').replace(/S{1}/g, '%1f').replace(/y{4}/g, '%Y').replace(/y{2}/g, '%y').replace(/M{4}/g, '%B').replace(/M{3}/g, '%b').replace(/M{2}/g, '%m').replace(/M{1}/g, '%-m').replace(/E{4,}/g, '%A').replace(/E{1,}/g, '%a').replace(/d{2}/g, '%d').replace(/([^%]|^)d{1}/g, '$1%-d').replace(/H{2}/g, '%H').replace(/h{2}/g, '%I').replace(/h{1}/g, '%-I').replace(/m{2}/g, '%M').replace(/s{2}/g, '%S').replace("'T'", 'T').replace(' z', ''); // timezone added as suffix if necessary

    var ticksuffix;
    var dataFormatter = formatter === null || formatter === void 0 ? void 0 : formatter.getColumnTypeFormatter(columnType);
    if (dataFormatter != null && isDateTimeColumnFormatter(dataFormatter) && dataFormatter.dhTimeZone != null && dataFormatter.showTimeZone) {
      ticksuffix = dh.i18n.DateTimeFormat.format(' z', new Date(), dataFormatter.dhTimeZone);
    }
    return {
      tickformat,
      ticksuffix,
      automargin: true
    };
  }

  /**
   * Gets the plotly axis formatting information from the source passed in
   * @param source The Source to get the formatter information from
   * @param formatter The current formatter for formatting data
   */
  getPlotlyAxisFormat(source) {
    var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var dh = this.dh;
    var axis = source.axis,
      columnType = source.columnType;
    var formatPattern = axis.formatPattern;
    var axisFormat = null;
    if (TableUtils.isDateType(columnType)) {
      axisFormat = this.getPlotlyDateFormat(formatter, columnType, formatPattern);
      axisFormat = ChartUtils.addTickSpacing(axisFormat, axis, true);
    } else if (TableUtils.isNumberType(columnType)) {
      axisFormat = ChartUtils.getPlotlyNumberFormat(formatter, columnType, formatPattern);
      axisFormat = ChartUtils.addTickSpacing(axisFormat, axis, false);
    }
    if (axis.formatType === dh.plot.AxisFormatType.CATEGORY) {
      if (axisFormat) {
        axisFormat.type = 'category';
      } else {
        axisFormat = {
          type: 'category',
          tickformat: undefined,
          ticksuffix: undefined
        };
      }
    }
    return axisFormat;
  }

  /**
   * Updates the axes positions and sizes in the layout object provided.
   * If the axis did not exist in the layout previously, it is created and added.
   * Any axis that no longer exists in axes is removed.
   * With Downsampling enabled, will also update the range on the axis itself as appropriate
   * @param layoutParam The layout object to update
   * @param chartAxes The chart axes to update the layout with
   * @param figureAxes All figure axes to update the layout with
   * @param plotWidth The width of the plot to calculate the axis sizes for
   * @param plotHeight The height of the plot to calculate the axis sizes for
   * @param bounds The bounds for this set of axes
   * @param axisRangeParser A function to retrieve the range parser for a given axis
   */
  updateLayoutAxes(layoutParam, chartAxes, figureAxes) {
    var plotWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var plotHeight = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var bounds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
      left: 0,
      top: 0,
      right: 1,
      bottom: 1
    };
    var axisRangeParser = arguments.length > 6 ? arguments[6] : undefined;
    var dh = this.dh;
    var xAxisSize = plotWidth > 0 ? Math.max(ChartUtils.MIN_AXIS_SIZE, Math.min(ChartUtils.AXIS_SIZE_PX / plotHeight, ChartUtils.MAX_AXIS_SIZE)) : ChartUtils.DEFAULT_AXIS_SIZE;
    var yAxisSize = plotHeight > 0 ? Math.max(ChartUtils.MIN_AXIS_SIZE, Math.min(ChartUtils.AXIS_SIZE_PX / plotWidth, ChartUtils.MAX_AXIS_SIZE)) : ChartUtils.DEFAULT_AXIS_SIZE;
    var layout = layoutParam;
    var axisPositionMap = ChartUtils.groupArray(chartAxes, 'position');
    var axisTypeMap = ChartUtils.groupArray(chartAxes, 'type');
    var axisTypes = [...axisTypeMap.keys()];
    var figureAxisTypeMap = ChartUtils.groupArray(figureAxes, 'type');
    for (var j = 0; j < axisTypes.length; j += 1) {
      var axisType = axisTypes[j];
      var axisProperty = this.getAxisPropertyName(axisType);
      if (axisProperty != null) {
        var typeAxes = axisTypeMap.get(axisType);
        var figureTypeAxes = figureAxisTypeMap.get(axisType);
        var isYAxis = axisType === dh.plot.AxisType.Y;
        var plotSize = isYAxis ? plotHeight : plotWidth;
        assertNotNull(typeAxes);
        assertNotNull(figureTypeAxes);
        for (var chartAxisIndex = 0; chartAxisIndex < typeAxes.length; chartAxisIndex += 1) {
          var _axis3 = typeAxes[chartAxisIndex];
          var figureAxisIndex = figureTypeAxes.indexOf(_axis3);
          var axisLayoutProperty = ChartUtils.getAxisLayoutProperty(axisProperty, figureAxisIndex);
          if (layout[axisLayoutProperty] == null) {
            layout[axisLayoutProperty] = {};
          }
          var layoutAxis = layout[axisLayoutProperty];
          if (layoutAxis != null) {
            this.updateLayoutAxis(layoutAxis, _axis3, chartAxisIndex, axisPositionMap, xAxisSize, yAxisSize, bounds);
            var _range = layoutAxis.range,
              autorange = layoutAxis.autorange;
            if (axisRangeParser != null && _range !== undefined && (autorange === undefined || autorange === false)) {
              var rangeParser = axisRangeParser(_axis3);
              var _rangeParser = rangeParser(_range),
                _rangeParser2 = _slicedToArray(_rangeParser, 2),
                rangeStart = _rangeParser2[0],
                rangeEnd = _rangeParser2[1];
              log.debug('Setting downsample range', plotSize, rangeStart, rangeEnd);
              _axis3.range(plotSize, rangeStart, rangeEnd);
            } else {
              _axis3.range(plotSize);
            }
          }
        }
      }
    }
  }

  /**
   * Remove any axes from the layout param that no longer belong to any series
   * @param layoutParam Layout object to remove stale axes from
   * @param axes All axes in the figure
   */
  removeStaleAxes(layoutParam, axes) {
    var layout = layoutParam;
    var figureAxisTypeMap = ChartUtils.groupArray(axes, 'type');
    var figureAxisTypes = [...figureAxisTypeMap.keys()];
    for (var i = 0; i < figureAxisTypes.length; i += 1) {
      var axisType = figureAxisTypes[i];
      var typeAxes = figureAxisTypeMap.get(axisType);
      assertNotNull(typeAxes);
      var axisIndex = typeAxes.length;
      // Delete any axes that may no longer exist
      var axisProperty = this.getAxisPropertyName(axisType);
      if (axisProperty != null) {
        var axisLayoutProperty = ChartUtils.getAxisLayoutProperty(axisProperty, axisIndex);
        while (layout[axisLayoutProperty] != null) {
          delete layout[axisLayoutProperty];
          axisIndex += 1;
          axisLayoutProperty = ChartUtils.getAxisLayoutProperty(axisProperty, axisIndex);
        }
      }
    }
  }

  /**
   * Updates the layout axis object in place
   * @param layoutAxisParam The plotly layout axis param
   * @param axis The Iris Axis to update the plotly layout with
   * @param axisIndex The type index for this axis
   * @param axisPositionMap All the axes mapped by position
   * @param axisSize The size of each axis in percent
   * @param bounds The bounds of the axes domains
   */
  updateLayoutAxis(layoutAxisParam, axis, axisIndex, axisPositionMap, xAxisSize, yAxisSize, bounds) {
    var _axis$label;
    var dh = this.dh;
    var isYAxis = axis.type === dh.plot.AxisType.Y;
    var axisSize = isYAxis ? yAxisSize : xAxisSize;
    var layoutAxis = layoutAxisParam;
    // Enterprise API returns null for empty axis labels
    // Passing null title text to Plotly results in incorrect axis position, DH-9164
    var label = (_axis$label = axis.label) !== null && _axis$label !== void 0 ? _axis$label : '';
    if (layoutAxis.title !== undefined && typeof layoutAxis.title !== 'string') {
      layoutAxis.title.text = label;
    } else {
      layoutAxis.title = {
        text: label
      };
    }
    if (axis.log) {
      layoutAxis.type = 'log';
    }
    layoutAxis.side = this.getAxisSide(axis.position);
    if (axisIndex > 0) {
      var _this$getAxisProperty, _axisPositionMap$get2;
      layoutAxis.overlaying = (_this$getAxisProperty = this.getAxisPropertyName(axis.type)) !== null && _this$getAxisProperty !== void 0 ? _this$getAxisProperty : undefined;
      var positionAxes = (_axisPositionMap$get2 = axisPositionMap.get(axis.position)) !== null && _axisPositionMap$get2 !== void 0 ? _axisPositionMap$get2 : [];
      var sideIndex = positionAxes.indexOf(axis);
      if (sideIndex > 0) {
        layoutAxis.anchor = 'free';
        if (axis.position === dh.plot.AxisPosition.RIGHT) {
          layoutAxis.position = bounds.right + (sideIndex - positionAxes.length + 1) * axisSize;
        } else if (axis.position === dh.plot.AxisPosition.TOP) {
          layoutAxis.position = bounds.top + (sideIndex - positionAxes.length + 1) * axisSize;
        } else if (axis.position === dh.plot.AxisPosition.BOTTOM) {
          layoutAxis.position = bounds.bottom + (positionAxes.length - sideIndex + 1) * axisSize;
        } else if (axis.position === dh.plot.AxisPosition.LEFT) {
          layoutAxis.position = bounds.left + (positionAxes.length - sideIndex + 1) * axisSize;
        }
      }
    } else if (axis.type === dh.plot.AxisType.X) {
      var leftAxes = axisPositionMap.get(dh.plot.AxisPosition.LEFT) || [];
      var rightAxes = axisPositionMap.get(dh.plot.AxisPosition.RIGHT) || [];
      var left = Math.max(bounds.left, bounds.left + (leftAxes.length - 1) * yAxisSize);
      var right = Math.min(bounds.right - (rightAxes.length - 1) * yAxisSize, bounds.right);
      layoutAxis.domain = [left, right];
    } else if (axis.type === dh.plot.AxisType.Y) {
      var bottomAxes = axisPositionMap.get(dh.plot.AxisPosition.BOTTOM) || [];
      var topAxes = axisPositionMap.get(dh.plot.AxisPosition.TOP) || [];
      var bottom = Math.max(bounds.bottom, bounds.bottom + (bottomAxes.length - 1) * xAxisSize);
      var top = Math.min(bounds.top - (topAxes.length - 1) * xAxisSize, bounds.top);
      layoutAxis.domain = [bottom, top];
    }

    // autorangeoptions exists in plotly.js but not in the types
    // axis.range only applies to the initial axis range, can't handle specifying min or max independently,
    // and cannot be returned to if the user changes the range via interaction
    // minallowed and maxallowed can be set independently and can be returned to if the user changes
    // the range via interaction
    var minRange = axis.minRange,
      maxRange = axis.maxRange,
      logAxis = axis.log;
    if (!Number.isNaN(minRange) || !Number.isNaN(maxRange)) {
      layoutAxis.autorangeoptions = {};
      if (!Number.isNaN(minRange)) {
        layoutAxis.autorangeoptions.minallowed = logAxis ? Math.log10(minRange) : minRange;
      }
      if (!Number.isNaN(maxRange)) {
        layoutAxis.autorangeoptions.maxallowed = logAxis ? Math.log10(maxRange) : maxRange;
      }
    }
  }

  /**
   * Creates the bounds for the periods specified.
   * For example, if you pass in [['09:00', '17:00']], it will return [17, 9] (closing at 5pm, opening at 9am the next day)
   * If you pass [['09:00', '12:00'], ['13:00', '17:00']], it will return [12, 13] (closing at noon, opening at 1pm) and [17, 9] (closing at 5pm, opening at 9am the next day)
   * @param periods Periods to map
   * @param timeZoneDiff Time zone difference in hours
   * @returns Bounds for the periods in plotly format
   */
  // eslint-disable-next-line class-methods-use-this
  createBoundsFromPeriods(periods) {
    var timeZoneDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (periods.length === 0) {
      return [];
    }
    var numberPeriods = periods.map(period => [(ChartUtils.periodToDecimal(period.open) + timeZoneDiff) % 24, (ChartUtils.periodToDecimal(period.close) + timeZoneDiff) % 24]).sort((a, b) => a[0] - b[0]);
    var bounds = [];
    for (var i = 0; i < numberPeriods.length; i += 1) {
      var period = numberPeriods[i];
      var nextPeriod = numberPeriods[(i + 1) % numberPeriods.length];
      bounds.push([period[1], nextPeriod[0]]);
    }
    return bounds;
  }

  /**
   * Creates range breaks for plotly from business periods.
   * @param periods Business periods to create the breaks for
   * @param timeZoneDiff Time zone difference in hours
   * @returns Plotly range breaks for the business periods
   */
  createBreaksFromPeriods(periods) {
    var timeZoneDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var bounds = this.createBoundsFromPeriods(periods, timeZoneDiff);
    return bounds.map(bound => ({
      pattern: 'hour',
      bounds: bound
    }));
  }

  /**
   * Creates range break bounds for plotly from business days.
   * For example a standard business week of ['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY']
   * will result in [[6,1]] meaning close on Saturday and open on Monday.
   * If you remove Wednesday from the array, then you get two closures [[6, 1], [3, 4]]
   *
   * @param businessDays the days to display on the x-axis
   */
  createBoundsFromDays(businessDays) {
    var weekLength = this.daysOfWeek.length;
    // No breaks if all days are business days
    if (businessDays.length === weekLength) {
      return [];
    }
    var businessDaysInt = businessDays.map(day => this.daysOfWeek.indexOf(day));
    var businessDaysSet = new Set(businessDaysInt);

    // These are the days when business is closed (e.g. Saturday to start the weekend)
    var closedDays = new Set();
    for (var i = 0; i < weekLength; i += 1) {
      if (!businessDaysSet.has(i) && businessDaysSet.has((i - 1 + weekLength) % weekLength)) {
        closedDays.add(i);
      }
    }
    var boundsArray = [];
    // For each close day, find the next open day
    closedDays.forEach(closedDay => {
      for (var _i = 0; _i < weekLength; _i += 1) {
        var adjustedDay = (closedDay + _i) % weekLength;
        if (businessDaysSet.has(adjustedDay)) {
          boundsArray.push([closedDay, adjustedDay]);
          return;
        }
      }
      throw new Error("Unable to find open day for closed day ".concat(closedDay, ", businessDays: ").concat(businessDays));
    });
    return boundsArray;
  }

  /**
   * Breaks in plotly for business days
   * @param businessDays Business days to create the breaks for
   * @returns Plotly range breaks for the business days
   */
  createBreaksFromDays(businessDays) {
    var bounds = this.createBoundsFromDays(businessDays);
    return bounds.map(bound => ({
      pattern: 'day of week',
      bounds: bound
    }));
  }

  /**
   * Creates range breaks for plotly from a business calendar.
   * @param businessCalendar Calendar to create the breaks from
   * @param formatter Formatter to use for time zones
   * @returns Plotly Rangebreaks for the business calendar
   */
  createRangeBreaksFromBusinessCalendar(businessCalendar, formatter) {
    var rangebreaks = [];
    var businessPeriods = businessCalendar.businessPeriods,
      businessDays = businessCalendar.businessDays,
      holidays = businessCalendar.holidays,
      calendarTimeZone = businessCalendar.timeZone;
    var typeFormatter = formatter === null || formatter === void 0 ? void 0 : formatter.getColumnTypeFormatter(BUSINESS_COLUMN_TYPE);
    var formatterTimeZone;
    if (isDateTimeColumnFormatter(typeFormatter)) {
      formatterTimeZone = typeFormatter.dhTimeZone;
    }
    var timeZoneDiff = ChartUtils.getTimeZoneDiff(calendarTimeZone, formatterTimeZone);
    if (holidays.length > 0) {
      rangebreaks.push(...this.createRangeBreakValuesFromHolidays(holidays, calendarTimeZone, formatterTimeZone, businessCalendar));
    }
    rangebreaks.push(...this.createBreaksFromPeriods(businessPeriods, timeZoneDiff));
    rangebreaks.push(...this.createBreaksFromDays(businessDays));
    return rangebreaks;
  }

  /**
   * Creates an array of range breaks for all holidays.
   *
   * @param holidays an array of holidays
   * @param calendarTimeZone the time zone for the business calendar
   * @param formatterTimeZone the time zone for the formatter
   * @param calendar the calendar the holidays are from
   */
  createRangeBreakValuesFromHolidays(holidays, calendarTimeZone, formatterTimeZone, calendar) {
    var fullHolidays = [];
    var partialHolidays = [];
    holidays.forEach(holiday => {
      if (holiday.businessPeriods.length > 0) {
        partialHolidays.push(...this.createPartialHoliday(holiday, calendarTimeZone, formatterTimeZone, calendar));
      } else {
        fullHolidays.push(this.createFullHoliday(holiday, calendarTimeZone, formatterTimeZone));
      }
    });
    return [{
      values: fullHolidays
    }, ...partialHolidays];
  }

  /**
   * Creates the range break value for a full holiday. A full holiday is day that has no business periods.
   *
   * @param holiday the full holiday
   * @param calendarTimeZone the time zone for the business calendar
   * @param formatterTimeZone the time zone for the formatter
   */
  createFullHoliday(holiday, calendarTimeZone, formatterTimeZone) {
    return this.adjustDateForTimeZone("".concat(holiday.date.toString(), " 00:00:00.000000"), calendarTimeZone, formatterTimeZone);
  }

  /**
   * Creates the range break for a partial holiday. A partial holiday is holiday with business periods
   * that are different than the default business periods.
   *
   * @param holiday the partial holiday
   * @param calendarTimeZone the time zone for the business calendar
   * @param formatterTimeZone the time zone for the formatter
   * @param calendar the calendar the holiday is from. Used to check against the default business periods to ensure this holiday needs to be specified
   *
   * @returns an array of range breaks for the partial holiday
   */
  createPartialHoliday(holiday, calendarTimeZone, formatterTimeZone, calendar) {
    var _calendar$businessPer;
    if (holiday.businessPeriods.length === 0) {
      return [];
    }
    var dateString = holiday.date.toString();

    // First check that the holiday is on a business day. If it's not, we can ignore it
    if (calendar) {
      var dayOfWeek = new Date(dateString).getDay();
      var isBusinessDay = calendar.businessDays.includes(this.daysOfWeek[dayOfWeek]);
      if (!isBusinessDay) {
        return [];
      }
    }
    var closedPeriods = ChartUtils.createClosedRangesForPartialHoliday(holiday.businessPeriods, (_calendar$businessPer = calendar === null || calendar === void 0 ? void 0 : calendar.businessPeriods) !== null && _calendar$businessPer !== void 0 ? _calendar$businessPer : []);
    var rangeBreaks = [];
    for (var i = 0; i < closedPeriods.length; i += 1) {
      var _closedPeriods$i = _slicedToArray(closedPeriods[i], 2),
        closeStart = _closedPeriods$i[0],
        closeEnd = _closedPeriods$i[1];
      // Skip over any periods where start and close are the same (zero hours)
      if (closeStart !== closeEnd) {
        var values = [this.adjustDateForTimeZone("".concat(dateString, " ").concat(ChartUtils.decimalToPeriod(closeStart), ":00.000000"), calendarTimeZone, formatterTimeZone)];
        var dvalue = MILLIS_PER_HOUR * (closeEnd - closeStart);
        rangeBreaks.push({
          values,
          dvalue
        });
      }
    }
    return rangeBreaks;
  }

  /**
   * Adjusts a date string from the calendar time zone to the formatter time zone.
   *
   * @param dateString the date string
   * @param calendarTimeZone the time zone for the business calendar
   * @param formatterTimeZone the time zone for the formatter
   */
  adjustDateForTimeZone(dateString, calendarTimeZone, formatterTimeZone) {
    if (formatterTimeZone && formatterTimeZone.standardOffset !== calendarTimeZone.standardOffset) {
      return this.unwrapValue(this.wrapValue(dateString, BUSINESS_COLUMN_TYPE, calendarTimeZone), formatterTimeZone);
    }
    return dateString;
  }

  /**
   * Creates the Figure settings from the Chart Builder settings
   * This should be deprecated at some point, and have Chart Builder create the figure settings directly.
   * This logic will still need to exist to translate existing charts, but could be part of a migration script
   * to translate the data.
   * Change when we decide to add more functionality to the Chart Builder.
   * @param settings The chart builder settings
   * @param settings.title The title for this figure
   * @param settings.xAxis The name of the column to use for the x-axis
   * @param settings.series The name of the columns to use for the series of this figure
   * @param settings.type The plot style for this figure
   */
  makeFigureSettings(settings, table) {
    var dh = this.dh;
    var series = settings.series,
      settingsAxis = settings.xAxis,
      type = settings.type;
    var title = ChartUtils.titleFromSettings(settings);
    var xAxis = {
      formatType: "".concat(dh.plot.AxisFormatType.NUMBER),
      type: "".concat(dh.plot.AxisType.X),
      position: "".concat(dh.plot.AxisPosition.BOTTOM)
    };
    var yAxis = {
      formatType: "".concat(dh.plot.AxisFormatType.NUMBER),
      type: "".concat(dh.plot.AxisType.Y),
      position: "".concat(dh.plot.AxisPosition.LEFT)
    };
    return {
      charts: [{
        chartType: "".concat(dh.plot.ChartType.XY),
        axes: [xAxis, yAxis],
        series: (series !== null && series !== void 0 ? series : []).map(name => ({
          plotStyle: "".concat(type),
          name,
          dataSources: [{
            type: "".concat(dh.plot.SourceType.X),
            columnName: settingsAxis !== null && settingsAxis !== void 0 ? settingsAxis : '',
            axis: xAxis,
            table
          }, {
            type: "".concat(dh.plot.SourceType.Y),
            columnName: name,
            axis: yAxis,
            table
          }]
        }))
      }],
      title
    };
  }

  /**
   * Unwraps a value provided from API to a value plotly can understand
   * Eg. Unwraps DateWrapper, LongWrapper objects.
   */
  unwrapValue(value, timeZone) {
    var dh = this.dh;
    if (value != null) {
      if (isDateWrapper(value)) {
        return dh.i18n.DateTimeFormat.format(ChartUtils.DATE_FORMAT, value, timeZone);
      }
      if (isLongWrapper(value)) {
        return value.asNumber();
      }
    }
    return value;
  }

  /**
   *
   * @param value The value to wrap up
   * @param columnType The type of column this value is from
   * @param timeZone The time zone if applicable
   */
  wrapValue(value, columnType) {
    var timeZone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var dh = this.dh;
    if (TableUtils.isDateType(columnType) && typeof value === 'string') {
      // Need to limit the format to the actual length of the string range set in plotly
      // Otherwise parse will fail
      var text = value;
      var format = ChartUtils.DATE_FORMAT.substr(0, value.length);
      var date = dh.i18n.DateTimeFormat.parse(format, text);
      if (!timeZone) {
        return date;
      }

      // IDS-5994 Due to date parsing, time zone, and daylight savings shenanigans, we need
      // to pass the actual offset with the time to have it parse correctly.
      // However, the offset can change based on the date because of Daylight Savings
      // So we end up parsing the date multiple times. And curse daylight savings.
      var tzFormat = "".concat(format, " Z");
      var estimatedOffset = dh.i18n.DateTimeFormat.format('Z', date, timeZone);
      var estimatedDate = dh.i18n.DateTimeFormat.parse(tzFormat, "".concat(text, " ").concat(estimatedOffset));
      var offset = dh.i18n.DateTimeFormat.format('Z', estimatedDate, timeZone);
      return dh.i18n.DateTimeFormat.parse(tzFormat, "".concat(text, " ").concat(offset));
    }
    return value;
  }
  makeLayoutAxis(type, theme) {
    var dh = this.dh;
    var axis = {
      automargin: true,
      gridcolor: theme.gridcolor,
      linecolor: theme.linecolor,
      rangeslider: {
        visible: false
      },
      showline: true,
      ticks: 'outside',
      ticklen: 5,
      // act as padding, can't find a tick padding
      tickcolor: theme.paper_bgcolor,
      // hide ticks as padding
      tickfont: {
        color: theme.zerolinecolor
      },
      title: {
        font: {
          color: theme.title_color
        }
      },
      legend: {
        font: {
          color: theme.legend_color
        }
      }
    };
    if (type === dh.plot.AxisType.X) {
      Object.assign(axis, {
        showgrid: true
      });
    } else if (type === dh.plot.AxisType.Y) {
      Object.assign(axis, {
        zerolinecolor: theme.zerolinecolor,
        zerolinewidth: 2
      });
    }
    return axis;
  }

  /**
   * Creates a plotly layout template object based on a given theme.
   * See https://plotly.com/javascript/reference/layout/#layout-template
   * @param theme The theme to use for the layout template
   * @returns The layout template object
   */
  makeDefaultTemplate(theme) {
    /* eslint-disable camelcase */
    var error_band_line_color = theme.error_band_line_color,
      ohlc_increasing = theme.ohlc_increasing,
      ohlc_decreasing = theme.ohlc_decreasing,
      title_color = theme.title_color,
      indicator_increasing = theme.indicator_increasing,
      indicator_decreasing = theme.indicator_decreasing,
      indicator_gauge = theme.indicator_gauge;
    return {
      data: {
        bar: [{
          marker: {
            line: {
              color: 'transparent'
            }
          }
        }],
        scatter: [{
          error_x: {
            color: error_band_line_color
          },
          error_y: {
            color: error_band_line_color
          }
        }],
        ohlc: [{
          increasing: {
            line: {
              color: ohlc_increasing
            }
          },
          decreasing: {
            line: {
              color: ohlc_decreasing
            }
          }
        }],
        pie: [{
          outsidetextfont: {
            color: title_color
          }
        }],
        treemap: [{
          outsidetextfont: {
            color: title_color
          }
        }],
        indicator: [{
          title: {
            font: {
              color: title_color
            }
          },
          delta: {
            decreasing: {
              color: indicator_decreasing
            },
            increasing: {
              color: indicator_increasing
            }
          },
          gauge: {
            bar: {
              color: indicator_gauge
            }
          }
        }]
      },
      /* eslint-enable camelcase */
      layout: this.makeDefaultLayout(theme)
    };
  }

  /**
   * Creates a plotly layout object based on a given theme.
   * See https://plotly.com/javascript/reference/layout/
   * @param theme The theme to use for the layout
   */
  makeDefaultLayout(theme) {
    var dh = this.dh;
    var paper_bgcolor = theme.paper_bgcolor,
      plot_bgcolor = theme.plot_bgcolor,
      title_color = theme.title_color,
      coastline_color = theme.coastline_color,
      land_color = theme.land_color,
      ocean_color = theme.ocean_color,
      lake_color = theme.lake_color,
      river_color = theme.river_color,
      map_style = theme.map_style;
    var layout = {
      paper_bgcolor,
      plot_bgcolor,
      autosize: true,
      colorway: ChartUtils.normalizeColorway(theme === null || theme === void 0 ? void 0 : theme.colorway),
      font: {
        family: "'Fira Sans', sans-serif",
        color: title_color
      },
      title: {
        font: {
          color: title_color
        },
        xanchor: 'center',
        xref: 'paper',
        yanchor: 'top',
        pad: _objectSpread({}, ChartUtils.DEFAULT_TITLE_PADDING),
        y: 1
      },
      legend: {
        font: {
          color: title_color
        }
      },
      margin: _objectSpread({}, ChartUtils.DEFAULT_MARGIN),
      xaxis: this.makeLayoutAxis(dh.plot.AxisType.X, theme),
      yaxis: this.makeLayoutAxis(dh.plot.AxisType.Y, theme),
      polar: {
        angularaxis: this.makeLayoutAxis(dh.plot.AxisType.SHAPE, theme),
        radialaxis: this.makeLayoutAxis(dh.plot.AxisType.SHAPE, theme),
        bgcolor: theme.plot_bgcolor
      },
      scene: {
        xaxis: this.makeLayoutAxis(dh.plot.AxisType.X, theme),
        yaxis: this.makeLayoutAxis(dh.plot.AxisType.Y, theme),
        zaxis: this.makeLayoutAxis(null, theme)
      },
      geo: {
        showcoastlines: true,
        showframe: false,
        showland: true,
        showocean: true,
        showlakes: true,
        showrivers: true,
        bgcolor: paper_bgcolor,
        coastlinecolor: coastline_color,
        landcolor: land_color,
        oceancolor: ocean_color,
        lakecolor: lake_color,
        rivercolor: river_color
      },
      map: {
        style: map_style
      }
    };
    layout.datarevision = 0;
    return layout;
  }

  /**
   * Hydrate settings from a JSONable object
   * @param settings Dehydrated settings
   */
  hydrateSettings(settings) {
    var dh = this.dh;
    return _objectSpread(_objectSpread({}, settings), {}, {
      type: settings.type != null ? dh.plot.SeriesPlotStyle[settings.type] : undefined
    });
  }
}
_defineProperty(ChartUtils, "DEFAULT_AXIS_SIZE", 0.15);
_defineProperty(ChartUtils, "MIN_AXIS_SIZE", 0.025);
_defineProperty(ChartUtils, "MAX_AXIS_SIZE", 0.2);
_defineProperty(ChartUtils, "AXIS_SIZE_PX", 75);
_defineProperty(ChartUtils, "LEGEND_WIDTH_PX", 50);
_defineProperty(ChartUtils, "MAX_LEGEND_SIZE", 0.25);
_defineProperty(ChartUtils, "ORIENTATION", Object.freeze({
  HORIZONTAL: 'h',
  VERTICAL: 'v'
}));
_defineProperty(ChartUtils, "DATE_FORMAT", 'yyyy-MM-dd HH:mm:ss.SSSSSS');
_defineProperty(ChartUtils, "DEFAULT_MARGIN", Object.freeze({
  l: 60,
  r: 50,
  t: 30,
  b: 60,
  pad: 0
}));
_defineProperty(ChartUtils, "DEFAULT_TITLE_PADDING", Object.freeze({
  t: 8
}));
_defineProperty(ChartUtils, "SUBTITLE_LINE_HEIGHT", 25);
_defineProperty(ChartUtils, "DEFAULT_MARKER_SIZE", 6);
_defineProperty(ChartUtils, "MODE_MARKERS", 'markers');
_defineProperty(ChartUtils, "MODE_LINES", 'lines');
export default ChartUtils;
//# sourceMappingURL=ChartUtils.js.map